import React, { useState } from "react";
import newslatter from "../assets/images/newslatter.png";
import emailIcon from "../assets/icons/email.svg";
import { toast } from 'sonner'
import axios from 'axios';

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); 

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.warning('Please Enter Email ID.');
      return;
    }

    setIsSubmitting(true); 

    const windowUrl = window.location.href;
    const hostname = new URL(windowUrl).hostname; // "jay.localhost"
    const parts = hostname.split(".");
    const subDomain = parts.length > 1 ? parts[0] : null;
    if (!subDomain) {
      window.location.href = process.env.REACT_APP_MARKETING_URL;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/front/newsletter/${subDomain}`, {
        email,
      });

      console.log('response::::::::::::::::::::::::: ', response);
      if (response) {
        toast.success('You have successfully subscribed!');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during subscription:", error);
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
      setEmail("");
    }
  };

  return (
    <div className="py-12 bg-gray-200 relative mt-[60%] sm:mt-[30%] md:mt-[30%] lg:mt-[14%]">
      <div className="absolute top-[-40%] left-0 right-0 flex justify-center">
        <img
          src={newslatter}
          alt="Newsletter Icon"
          className="h-[250px] w-auto sm:h-[200px] md:h-[250px]"
        />
      </div>
      <div className="container pt-[82px] mx-auto px-4 md:px-10 flex flex-row md:flex-row justify-center items-center gap-8">

        <div className="text-center md:text-center w-full md:w-1/2">
          <h2 className="text-4xl font-semibold mb-4 mt-4 ">
            Subscribe <span className="text-primary_main">Newsletter</span>
          </h2>
          <p className="text-gray-600 mb-4 text-lg">
            You will never miss our latest posts and news!
            <br />We promise we will never spam you.
          </p>
          <div className="flex justify-center md:justify-center items-center gap-4">
            <div className="relative w-full max-w-xs">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter Your Email ID"
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <img
                src={emailIcon}
                alt="Email Icon"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5"
              />
            </div>
          </div>
          <button
            onClick={handleSubmit}
            className="bg-secondary_main text-white text-base px-8 py-2 mt-5 rounded-lg font-bold"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Subscribing..." : "Subscribe"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
